module.exports = __webpack_public_path__ + "img/scanned-document-original.c64e31eb.webp";